import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

export interface DeleteRecordingDialogData {
  hasTranscription: boolean;
  hasRecording: boolean;
}

export interface DeleteRecordingDialogResult {
  deleteRecording: boolean;
  deleteTranscription: boolean;
}

@Component({
  selector: 'app-delete-recording-dialog',
  templateUrl: './delete-recording-dialog.component.html',
  styleUrls: ['./delete-recording-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    FlexModule,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    NgIf,
    MatButton,
  ],
})
export class DeleteRecordingDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeleteRecordingDialogData,
    private _dialogRef: MatDialogRef<DeleteRecordingDialogComponent, DeleteRecordingDialogResult>,
  ) {}

  get hasRecordingAndTranscription(): boolean {
    const { hasRecording, hasTranscription } = this.data;
    return hasRecording && hasTranscription;
  }

  get hasOnlyRecording(): boolean {
    const { hasRecording, hasTranscription } = this.data;
    return hasRecording && !hasTranscription;
  }

  get hasOnlyTranscription(): boolean {
    const { hasRecording, hasTranscription } = this.data;
    return !hasRecording && hasTranscription;
  }

  public onDialogClose(data: DeleteRecordingDialogResult): void {
    this._dialogRef.close(data);
  }
}
